export enum NavigationDirection {
    Forward = 'forward',
    Backward = 'backward'
  }